import React from "react";
import styles from "./style.module.scss";

interface IProps {
  title?: string;
  children: JSX.Element | JSX.Element[];
}

export default function ContentLayout({title, children}: IProps) {
  return (
    <div className={styles.container}>
      <h1>{title}</h1>
      {children}
    </div>
  );
}
